<template>
	<div
		v-if="workbookHasPermission('field_plotHelper')"
		class="timeline-helper-outter"
	>
		<r-standard-icon
			class="helper-icon"
			:class="{
				warn: theme === 'warn',
				clickable: clickable === true,
			}"
			:icon="displayIcon"
			:color="iconThemeColor"
			@click="$emit('click')"
			@pointerdown="$emit('pointerdown')"
		/>
	</div>
</template>

<script type="text/javascript">

import AbstractPicklistController from 'js/data-store/abstract-picklist-controller';

export default {
	inject:['sheetGlobalState', 'workbookHasPermission', 'fieldCache'],
	props:{
		sheetView:{
			required: true,
			type: Object,
		},
		record:{
			required: true,
			type: Object,
		},
		clickable:{
			required: false,
			type: Boolean,
			default: false,
		}
	},
	$pubsub:{
		helperIndicator:{},
	},
	data(){
		return {
			picklistController: AbstractPicklistController,
		};
	},
	watch:{
		canPlotRecord:{
			immediate: true,
			handler(newValue, oldValue){
				this.$emit('helperIndicatorChanged', newValue.isValid);
			}
		}
	},
	computed:{
		sheetViewType(){
			return this.sheetView.type;
		},
		canPlotRecord(){
			if(this.sheetViewType === 'gantt'){
				return this.sheetView.ganttCanPlotRecord(this.record, this.sheetGlobalState.dataStoreRecordsByLevels);
			}
			else if(this.sheetViewType === 'timeline'){
				return this.sheetView.timelineCanPlotRecord(this.record, this.sheetGlobalState.dataStoreRecordsByLevels, this.fieldCache, this.$root.systemState, this.sheetGlobalState.ConnectedApps);
			}
			else{
				return false;
			}
		},
		theme(){
			if(!this.canPlotRecord.isValid){
				return 'warn';
			}
			return '';
		},
		displayIcon(){
			if(this.sheetViewType === 'gantt'){
				if(this.theme === "warn"){
					return 'plottedSlash';
				}
				return 'sheetViewGantt';
			}
			else{
				if(this.theme === "warn"){
					return 'plottedSlash';
				}
				return 'plottedIcon';
			}
		},
		iconThemeColor(){
			if(this.theme === "warn"){
				return "grey-300";
			}
			return "blue-300";
		},
	},
}
</script>

<style lang="scss" scoped>
.timeline-helper-outter{
	width: 24px;
	height: 24px;
	
	.helper-icon{
		border-radius: 3px;
		background-color: transparent;

		&.clickable{
			@include clickable;
		}

		&.warn{
			background-color: transparent;
		}
	}
}

</style>
